import { PLAN_TIER_ORDER } from '../constants/planCheckout.constants';

export const sortPlansPremiumFirst = (planList) =>
	[...planList].sort(
		(a, b) => PLAN_TIER_ORDER.indexOf(a.name) - PLAN_TIER_ORDER.indexOf(b.name),
	);

export const getDefaultPremiumPlanName = (planList) =>
	planList.find((plan) => plan.name === 'PREMIUM')?.name ?? planList[0]?.name;
